import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const apiVersion = '/api/v1';

export const http = axios.create({
  baseURL: `${apiVersion}`,
  withCredentials: true,
});

http.interceptors.response.use(null, (error) => {
  const { response: { status, data = {} } = {} } = error;
  if (status >= 400 && status < 500) {
    if (typeof data !== 'object') {
      return Promise.resolve(data);
    }
    if (!data?.status) data.status = status; // inject `status` if not already there
    return Promise.resolve(data);
  }
});

http.interceptors.request.use(
  function (config) {
    const contentType = 'application/json';
    config.headers = {
      'X-App': 'web',
      'X-Request-ID': uuidv4(),
      'Content-Type': contentType,
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
